import { datadogLogs } from '@datadog/browser-logs'

// Logger instance with a custom logger.name, for example 'output.audit', 'input.validator', etc.
export const datadogLogger = (loggerName: string) => {
  return datadogLogs.getLogger(loggerName) ?? datadogLogs.createLogger(loggerName, {handler: ['http', 'console']})
}
